module.exports = __webpack_public_path__ + "img/people-06.762b778c.png";